import './TextOnBackground.scss';

class TextOnBackground {

  constructor(node) {
    this.node = node;
  }

  init() {
    //console.log();
  }

}

JSModules['TextOnBackground'] = TextOnBackground;
export default TextOnBackground;
